export default {
  headerContent: {
    title: 'Quick Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Quick Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'Gündelik yaşamın akışı içerisinde pek çok talihsiz durum ile karşılaşmak mümkündür. Çünkü yaşam beklenmedik sürprizlerle doludur ve bu sürprizler bazen canımızı yakabilir. Kazalar sonucunda oluşan can sıkıcı durumların önemli taraflarından birisi de ekonomik güçlüklerdir çünkü kaza hiç beklenmeyen bir an gelmiştir ve ekonomik olarak sebep olacağı güçlükler önceden hesaplanmamıştır. Ama ferdi kaza sigortası ile bu durumlara karşı önlem almak mümkündür.',
        '<strong>Quick Sigorta ferdi kaza sigortası</strong>, sigortalı kişiyi kaza durumlarına karşı güvenceye alan ve ilgili kazaların gerçekleşmesi durumunda sigortalının kendisine ya da aile yakınlarına tazminat ödemesi yapan sigorta türüdür. Kazaların içeriği poliçede belirtilmiş olmakla beraber neredeyse her kazaya karşı güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Quick Sigorta kişilerin kaza yaşama risklerini göz önünde tutarak geniş kapsamlı teminatlar sunmaktadır. Bu teminatlar kapsamında trafik kazalarından böcek ısırmalarına kadar geçerli olacak kazaların neredeyse tamamı güvence altına alınmaktadır. Aynı zamanda ek teminatlar ile kaza durumlarına karşılık poliçe kapsamı da genişletilmektedir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
